import { render, staticRenderFns } from "./VerifyRefer.vue?vue&type=template&id=c87bb2c2&scoped=true&"
import script from "./VerifyRefer.vue?vue&type=script&lang=js&"
export * from "./VerifyRefer.vue?vue&type=script&lang=js&"
import style0 from "./VerifyRefer.vue?vue&type=style&index=0&id=c87bb2c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87bb2c2",
  null
  
)

export default component.exports